import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
  UnifiedTheme,
  UnifiedThemeOptions,
} from '@backstage/theme';
import { brand, fontFamily } from './brand';

const pageTheme = {
  home: genPageTheme({ colors: [brand.navy, brand.blue], shape: shapes.wave }),
  documentation: genPageTheme({
    colors: [brand.pinkDark, brand.pink],
    shape: shapes.wave2,
  }),
  tool: genPageTheme({ colors: [brand.ink, brand.slate], shape: shapes.round }),
  service: genPageTheme({
    colors: [brand.navy, brand.blue],
    shape: shapes.wave,
  }),
  website: genPageTheme({
    colors: [brand.pinkDark, brand.purple],
    shape: shapes.wave,
  }),
  library: genPageTheme({
    colors: [brand.navy, brand.slate],
    shape: shapes.wave,
  }),
  other: genPageTheme({ colors: [brand.ink, brand.navy], shape: shapes.wave }),
  app: genPageTheme({ colors: [brand.navy, brand.pink], shape: shapes.wave }),
  apis: genPageTheme({ colors: [brand.navy, brand.green], shape: shapes.wave }),
  card: genPageTheme({ colors: [brand.navy, brand.blue], shape: shapes.wave }),
};

const navigation = {
  background: brand.navy,
  indicator: brand.pink,
  color: '#b9c0d9',
  selectedColor: '#ffffff',
  navItem: { hoverBackground: brand.navyMuted },
  submenu: { background: brand.navyMuted },
};

const components: UnifiedThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: { fontFamily },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 600, borderRadius: 8 },
    },
  },
  MuiPaper: {
    styleOverrides: {
      rounded: { borderRadius: 12 },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: { borderRadius: 6 },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 600 },
    },
  },
};

export const itgLightTheme: UnifiedTheme = createUnifiedTheme({
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
  components,
  palette: {
    ...palettes.light,
    background: { default: '#f4f6fb', paper: '#ffffff' },
    primary: { main: brand.blue, dark: '#1b47cc', light: brand.blueSoft },
    secondary: { main: brand.pink },
    link: brand.blue,
    linkHover: '#1b47cc',
    border: '#dfe3ee',
    textSubtle: '#5b6478',
    navigation,
    tabbar: { indicator: brand.pink },
    status: { ...palettes.light.status, running: brand.blue },
  },
});

export const itgDarkTheme: UnifiedTheme = createUnifiedTheme({
  fontFamily,
  defaultPageTheme: 'home',
  pageTheme,
  components,
  palette: {
    ...palettes.dark,
    background: { default: '#0f1020', paper: '#181a2f' },
    primary: { main: brand.blueSoft, dark: '#6d8cff', light: brand.blueLight },
    secondary: { main: '#ff7ee6' },
    link: brand.blueSoft,
    linkHover: brand.blueLight,
    border: '#2a2d4a',
    textSubtle: '#a3a9c4',
    navigation: { ...navigation, background: '#060222' },
    tabbar: { indicator: '#ff7ee6' },
    status: { ...palettes.dark.status, running: brand.blueSoft },
  },
});
